module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item-image",
    attrs: {
      "id": _vm.divId
    }
  }, [_c('div', {
    staticClass: "product-item-image-wrapper"
  }, [(_vm.product.isDemoVideo) ? _c('div', {
    staticClass: "cover-demo-bar"
  }) : _vm._e(), _vm._v(" "), (_vm.product.device.color == 'black') ? _c('img', {
    staticClass: "product-item-image-overlay",
    attrs: {
      "src": require("../../assets/iphone-7-white.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.device.color == 'white') ? _c('img', {
    staticClass: "product-item-image-overlay",
    attrs: {
      "src": require("../../assets/iphone-7-white.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('video', {
    staticClass: "attach-video-holder",
    attrs: {
      "id": _vm.videoId,
      "src": _vm.currentImage,
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  }), _vm._v(" "), (_vm.currentImageOptions > 1) ? _c('div', {
    staticClass: "product-item-image-gallery"
  }, _vm._l((_vm.product.images), function(url, imageKey) {
    return _c('span', {
      staticClass: "product-item-gallery-item",
      class: [_vm.currentImageKey == imageKey ? 'active-class' : ''],
      on: {
        "click": function($event) {
          return _vm.setGalleryImage(imageKey)
        }
      }
    }, [_vm._v(_vm._s(imageKey))])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50b375ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/AttachProductComponents/ProductImageComponent.vue
// module id = 475
// module chunks = 0